<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'center', orientation: 'vertical'}}}"
      :stacked="true"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :markers="{size:[0,6]}"
      :data-labels="{enabled: true, enabledOnSeries: [0], formatter: function (val, {dataPointIndex}) {
        return labels.velocity[dataPointIndex] !== undefined && labels.velocity[dataPointIndex] !== null ? labels.velocity[dataPointIndex] + '%' : ''
      }}"
      :stroke="{show: false}"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[ { title: { text: $t('chart_legends.velocity') }} ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#c42b59', '#df7595' ]"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ $t('card_title.max_velocity_vs_all_time') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3"
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
              <visual-list-toggle
                v-else
                :value.sync="viewMode"
              />
            </v-col>
          </v-row>
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div
              class="subtitle-2 grey--text text--grey-100"
              style="word-break: normal"
            >
              {{ $t('card_title.max_velocity_vs_all_time') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="ml-3"
          >
            <visual-list-toggle
              v-if="!removable"
              :value.sync="viewMode"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="players"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'MaxVelocityChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    labels: {},
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('CACGCSMXV'), type: 'bar', label: this.$t('chart_legends.maximum_velocity_km_h') },
        { key: addAggregation('UXMAXVELALL'), type: 'line', label: this.$t('chart_legends.maximum_velocity_all_time') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('chart_legends.maximum_velocity_km_h'),
          value: valuePrefix + addAggregation('CACGCSMXV'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.maximum_velocity_all_time'),
          value: valuePrefix + addAggregation('UXMAXVELALL'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.players.map(player => {
      const stats = this.aggregation && !this.removable ? player.latest_stats : player.player_stats
      if (!stats) return player

      const prefix = this.aggregation && !this.removable ? `_${this.aggregation}` : ''
      const maxVelKey = `CACGCSMXV${prefix}`
      const maxVelRefKey = `UXMAXVELREF${prefix}`
      const maxVelAllKey = `UXMAXVELALL${prefix}`

      if (stats[maxVelKey] && stats[maxVelRefKey]) {
        stats[maxVelAllKey] = Math.round((stats[maxVelKey] / (stats[maxVelRefKey] / 100)) * 100) / 100
      }

      return player
    })

    this.labels.velocity = this.players.map(player => player.player_stats?.UXMAXVELREF)
  }
}
</script>
